module.exports = __webpack_public_path__ + "img/formation_Reglementation.e8df800b.png";